import React, { Component } from 'react';
import { apiPut, apiPost, apiDelete } from '../../Api';
import ItemList from './Admin_Items_List';
import ItemDetail from './Admin_Items_Detail';
import ItemsModal from './ItemsModal'
import AdminAPI from './AdminAPI';
import withRouter from '../../withRouter';

const read = (value, camelName, pascalName) => (
  value?.[camelName] ?? value?.[pascalName]
);

const itemIdFromSearch = search => (
  new URLSearchParams(search || '').get('itemId') || ''
);

export function itemRecipeLearningPayload(item) {
  const unlockMode = String(
    read(item, 'recipeUnlockMode', 'RecipeUnlockMode') || 'automatic',
  ).toLowerCase();
  const professionKey = String(
    read(item, 'professionKey', 'ProfessionKey') || '',
  );
  return {
    isCraftable: true,
    requiredProfessionLevel: Math.max(
      1,
      Number(read(
        item,
        'requiredProfessionLevel',
        'RequiredProfessionLevel',
      )) || 1,
    ),
    recipeTier: Math.min(5, Math.max(
      1,
      Number(read(item, 'recipeTier', 'RecipeTier')) || 1,
    )),
    craftedRarityId: String(
      read(item, 'craftedRarityId', 'CraftedRarityId') || '',
    ),
    recipeUnlockMode: unlockMode,
    recipeItemId: unlockMode === 'discovered'
      ? String(read(item, 'recipeItemId', 'RecipeItemId') || '')
      : '',
    salvagesRequiredToLearn: unlockMode === 'salvage'
      ? Math.max(
        1,
        Number(read(
          item,
          'salvagesRequiredToLearn',
          'SalvagesRequiredToLearn',
        )) || 10,
      )
      : 0,
    craftingStationKey: String(
      read(item, 'craftingStationKey', 'CraftingStationKey') || '',
    ),
    fieldCraftable: Boolean(
      read(item, 'fieldCraftable', 'FieldCraftable') ?? true,
    ),
    craftingDurationSeconds: Math.max(
      professionKey === 'cooking' ? 1 : 0,
      Number(read(
        item,
        'craftingDurationSeconds',
        'CraftingDurationSeconds',
      )) || 0,
    ),
  };
}

export class Admin_Items extends Component {


  constructor(props) {
    super(props);
    this.state = {
      items: [],


      creatingNewItem: false,
      selectedItemId: "",
      itemTypes: [],
      stats: [],
      consumableEffectTargets: [],

      rarity: [],
      enemyTypes: [],
      enemies: [],
      regions: [],
      starterItemIds: new Set(),
      showItemPopup: false,//modal
    }
  }

  handleSelectItemPopup = (item) => {//Modal
    this.setState({
      selectedItemPopup: item,
      showItemPopup: false
    });
  }

  showItemPopup = () => {
    this.setState({ showItemPopup: true })
  }

  componentDidMount = async () => {
    const [
      itemValues,
      itemTypes,
      stats,
      consumableEffectTargets,
      rarity,
      enemyTypes,
      regions,
      enemies,
      starterKits,
    ] = await Promise.all([
      AdminAPI.getItems(),
      AdminAPI.getItemTypes(),
      AdminAPI.getStats(),
      AdminAPI.getConsumableEffectTargets().catch(() => []),
      AdminAPI.getRarity(),
      AdminAPI.getEnemyTypes(),
      AdminAPI.getRegions(),
      AdminAPI.getEnemies(),
      AdminAPI.getStarterKits().catch(() => []),
    ]);
    const items = itemValues || [];
    const deepLinkedItemId = itemIdFromSearch(
      this.props.router?.location?.search,
    );
    const deepLinkedItem = items.find(item => (
      String(read(item, 'id', 'Id') || '') === deepLinkedItemId
    ));
    this.setState({
      items,
      itemTypes: itemTypes || [],
      stats: stats || [],
      consumableEffectTargets: consumableEffectTargets || [],
      rarity: rarity || [],
      enemyTypes: enemyTypes || [],
      regions: regions || [],
      enemies: enemies || [],
      starterItemIds: new Set(
        (starterKits || []).flatMap(kit => (
          read(kit, 'entries', 'Entries') || []
        )).map(entry => String(
          read(entry, 'itemId', 'ItemId') || '',
        )).filter(Boolean),
      ),
      ...(deepLinkedItem ? {
        selectedItem: deepLinkedItem,
        selectedItemId: deepLinkedItem.id,
        creatingNewItem: false,
      } : {}),
    });
  }

  componentDidUpdate(prevProps) {
    const previousItemId = itemIdFromSearch(prevProps.router?.location?.search);
    const selectedItemId = itemIdFromSearch(this.props.router?.location?.search);
    if (selectedItemId === previousItemId) return;
    if (!selectedItemId && this.state.creatingNewItem) return;

    const selectedItem = this.state.items.find(item => (
      String(read(item, 'id', 'Id') || '') === selectedItemId
    ));
    this.setState({
      selectedItem: selectedItem || null,
      selectedItemId: selectedItem ? selectedItemId : '',
      creatingNewItem: false,
    });
  }

  navigateToItem = (itemId, options = {}) => {
    const location = this.props.router?.location;
    const params = new URLSearchParams(location?.search || '');
    if (itemId) {
      params.set('itemId', itemId);
    } else {
      params.delete('itemId');
    }
    const query = params.toString();
    const search = query ? `?${query}` : '';
    if (search === (location?.search || '')) return;

    this.props.router?.navigate(
      { pathname: location?.pathname || '/admin/Items', search },
      options,
    );
  };



  handleSelectItem = (item) => {

    const itemId = String(read(item, 'id', 'Id') || '');
    this.navigateToItem(itemId);

    this.setState({
      selectedItem: item,
      creatingNewItem: false,
      selectedItemId: itemId,
    });

  };

  handleNewItem = () => {
    this.selectedItem = null;
    console.log("newitem");
    this.navigateToItem('');
    this.setState({
      creatingNewItem: true,
      selectedItem: {},
      selectedItemId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedItem: null,
      creatingNewItem: false,
    });
  };

  handleUpdate = async (item) => {
    const response = await apiPut("/item", JSON.stringify(item));
    if (response.ok) {
      this.setState({ items: await AdminAPI.getItems() });
      this.setState({ selectedItemId: null });
      this.navigateToItem('', { replace: true });
    }
  };

  handleUpdateRecipeLearning = async (item) => {
    const itemId = String(read(item, 'id', 'Id') || '');
    const professionKey = String(
      read(item, 'professionKey', 'ProfessionKey') || '',
    );
    if (!itemId || !professionKey) {
      throw new Error(
        'Assign this item to a profession before configuring recipe learning.',
      );
    }
    const saved = await AdminAPI.saveProfessionRecipe(
      professionKey,
      itemId,
      itemRecipeLearningPayload(item),
    );
    this.setState({ items: await AdminAPI.getItems() });
    return saved;
  };

  handleDelete = async (item) => {
    // Send delete request to your backend
    const response = await apiDelete("/item/" + item.id);
    if (response.ok) {
      this.setState({ items: await AdminAPI.getItems() });
      this.setState({ selectedItemId: null });
      this.navigateToItem('', { replace: true });
    }
  };

  handleCreate = async (item) => {
    // Send delete request to your backend
    const response = await apiPost("/item", JSON.stringify(item));

    if (response.ok) {
      this.setState({ items: await AdminAPI.getItems() });
      this.setState({ selectedItemId: null });
      this.navigateToItem('', { replace: true });
    }
    else {
      window.alert(response.text());
    }
  };

  handleSearch = (searchQuery) => {
    // Filter the items based on search query
  };






  render() {
    const { items, creatingNewItem } = this.state;
    const { showItemPopup } = this.state;
    return (
      <div className="admin-settingspage">
        <ItemList
          items={items}
          enemies={this.state.enemies}
          filter={this.props.filter}
          regions={this.state.regions}
          onSelectItem={this.handleSelectItem}
          onSearch={this.handleSearch}
          onNewItem={this.handleNewItem}
          itemTypes={this.state.itemTypes}
        />



        <ItemDetail
          items={this.state.items}
          regions={this.state.regions}
          enemies={this.state.enemies}
          creatingNewItem={creatingNewItem}
          itemId={this.state.selectedItemId}
          itemTypes={this.state.itemTypes}
          rarity={this.state.rarity}

          enemyTypes={this.state.enemyTypes}
          stats={this.state.stats}
          consumableEffectTargets={this.state.consumableEffectTargets}
          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
          showItemPopup={this.showItemPopup}
          selectedItemPopup={this.state.selectedItemPopup}
          starterItemIds={this.state.starterItemIds}
          onUpdateRecipeLearning={this.handleUpdateRecipeLearning}

        />
        {showItemPopup && <ItemsModal onSelect={this.handleSelectItemPopup} onClose={() => this.setState({ showItemPopup: false })} />}
      </div>
    );
  }
}

export default withRouter(Admin_Items);
